import React, { HTMLAttributes } from 'react';
import Card from '../Card/Card';
import { useNavigate } from 'react-router-dom';
import { ROUTE_NAMES } from '#/router/routes';

const padding = 'py-2 px-3';

interface IPropertiesNavBarMnuItem {
  icon: string;
  text: string;
  onClick: HTMLAttributes<HTMLLIElement>['onClick'];
}

const SideNavBarMenuItem = ({
  icon,
  text,
  onClick,
}: IPropertiesNavBarMnuItem) => (
  <li
    onClick={onClick}
    className="font-bold h-theme-nav-bar-item-height flex gap-1 items-center transition-colors duration-300 hover:cursor-pointer hover:text-theme-white"
  >
    <span className="material-icons text-3xl mr-3">{icon}</span>
    <span>{text}</span>
  </li>
);

const SideNavBar = () => {
  const navigate = useNavigate();

  const handleOnClickHome = () => navigate(ROUTE_NAMES.HOME);
  // TODO: update to redirect to search
  const handleOnClickSearch = () => navigate(ROUTE_NAMES.SEARCH);

  return (
    <div className="flex flex-col gap-2 text-theme-light-gray">
      <Card className={padding}>
        <ul className="flex flex-col gap-2 py-1 px-3">
          <SideNavBarMenuItem
            icon="home"
            text="Home"
            onClick={handleOnClickHome}
          />
          <SideNavBarMenuItem
            icon="search"
            text="Search"
            onClick={handleOnClickSearch}
          />
        </ul>
      </Card>
    </div>
  );
};

export default SideNavBar;
